import { Tag, Typography } from "antd";

const { Text } = Typography;

interface IncomingFBCallStatusProps {
  state: "incoming" | "connecting" | "connected" | "ended";
  duration: number;
  direction?: "BUSINESS_INITIATED" | "USER_INITIATED";
}

export const IncomingFBCallStatus = ({
  state,
  duration,
  direction,
}: IncomingFBCallStatusProps) => {
  const formatDuration = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  const getStatusColor = () => {
    switch (state) {
      case "incoming":
        return "orange";
      case "connecting":
        return "blue";
      case "connected":
        return "green";
      case "ended":
        return "red";
      default:
        return "default";
    }
  };

  const getStatusText = () => {
    switch (state) {
      case "incoming":
        return "Incoming";
      case "connecting":
        return "Connecting";
      case "connected":
        return "Connected";
      case "ended":
        return "Ended";
      default:
        return "Unknown";
    }
  };

  const getDirectionText = () => {
    if (!direction) return null;

    switch (direction) {
      case "BUSINESS_INITIATED":
        return "Outgoing";
      case "USER_INITIATED":
        return "Incoming";
      default:
        return direction;
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <Tag color={getStatusColor()}>{getStatusText()}</Tag>

      {direction && <Tag color="default">{getDirectionText()}</Tag>}

      {state === "connected" && duration > 0 && (
        <Text type="secondary" className="text-xs">
          {formatDuration(duration)}
        </Text>
      )}
    </div>
  );
};
